// @flow

import React from 'react';
import geminiApi from '../../../../../network/api/geminiApi';
import { getCurrentPcId } from '../../../../../utils/urlUtils';
import EllipsisLoader from '../../../../../components/EllipsisLoader';
import type { CoqueRetailer, GoodwillType } from '../../../../../types/apolloType';
import GoodwillOverlay from './GoodwillOverlay';
import type { VisioglobeUnitsMap } from '../../../../../types/geminiType';

type Props = {
  mapviewer: MapViewer,
  scrollableElement?: ?HTMLDivElement,
  bestRetailer: CoqueRetailer,
  topRetailerIds: Array<number>,
  isGoodwillLoading: boolean,
  selectedRatioName: string,
  goodwill: GoodwillType,
}

type State = {
  visioglobeUnitsMap: ?VisioglobeUnitsMap,
}

class GoodwillBaseOverlay extends React.Component<Props, State> {
  static defaultProps = {
    scrollableElement: null,
  };

  state = {
    visioglobeUnitsMap: null,
  };

  updateVisioglobeUnits = () => {
    this.setState({
      visioglobeUnitsMap: null,
    }, () => {
      // null will fetch most recent year
      geminiApi.fetchVisioglobeUnits(getCurrentPcId(), null)
        .then(res => res.json())
        .then((visioglobeUnitsMap: VisioglobeUnitsMap) => {
          this.setState({ visioglobeUnitsMap });
        });
    });
  }

  componentDidMount() {
    this.updateVisioglobeUnits();
  }

  render() {
    if (this.props.isGoodwillLoading || !this.state.visioglobeUnitsMap) {
      return (
        <div className="loader-screen">
          <EllipsisLoader />
        </div>
      );
    }

    return (
      <GoodwillOverlay
        mapviewer={this.props.mapviewer}
        updateVisioglobeUnits={this.updateVisioglobeUnits}
        scrollableElement={this.props.scrollableElement}
        visioglobeUnitsMap={this.state.visioglobeUnitsMap}
        bestRetailer={this.props.bestRetailer}
        topRetailerIds={this.props.topRetailerIds}
        selectedRatioName={this.props.selectedRatioName}
        goodwill={this.props.goodwill}
      />
    );
  }
}

export default (GoodwillBaseOverlay);
